<template>
  <b-container fluid>
    <b-row class="ctrl-dir">
      <b-col cols="8">
        <h4 class="about-title">{{ ls_GrammarRules }}</h4>
        <div class="grammar-container">
          <div class="grammar-tab-content">
            <b-row>
              <b-col v-for="(item, index) in grammarList" :key="index" cols="4">
                <b-link v-scroll-to="'#item' + index" class="grammar-tab-item" :style="{ backgroundColor: item.sectionColor }">
                  <h5 class="item-number">{{ item.sectionIndex }}</h5>
                  <p class="item-title">{{ item.title }}</p>
                </b-link>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-for="(item, index) in grammarList" :key="index" cols="12">
                <div :id="'item' + index" class="grammar-content-item">
                  <h5 class="content-title">
                    {{ item.title }}
                  </h5>
                  <div class="grammar-tab-content" v-html="item.content"></div>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
      <b-col cols="4">
        <div class="w-100 my-5"></div>
        <sidebar-menu
          :menuTitle="ls_Menu"
          :menuList="alphabetMenuList"
          :currentMenu="currentMenu">
        </sidebar-menu>
        <div class="sticky-top">
          <div class="about-examples">
            <div class="latyn-example">
              <p class="example-content">
                {{ example.latynContent }}
              </p>
              <p class="example-author">
                {{ example.latynAuthor }}
              </p>
            </div>
            <div class="cyrl-example">
              <p class="example-content">
                {{ example.content }}
              </p>
              <p class="example-author">
                {{ example.author }}
              </p>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import SidebarNavigation from "@/components/navigation/SidebarNavigation.vue";
export default {
  data() {
    return {
      grammarList: [],
      example: {}
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    menuList() {
      if (this.$store.state.navigationList.length <= 0) return;
      return this.$store.state.navigationList.filter(
        n => n.url === "/alphabet"
      )[0].childList;
    },

    ls_GrammarRules() {
      return this.$store.state.languagePack.ls_GrammarRules;
    },

    ls_Menu() {
      return this.$store.state.languagePack.ls_Menu;
    },

    currentMenu() {
      if (!this.menuList) return;
      return this.menuList.filter(m => this.$route.path.includes(m.url))[0];
    },

    alphabetMenuList() {
      let alphabetMenus = [];
      if (this.menuList) {
        this.menuList.forEach(function(menu) {
          alphabetMenus.push({
            url: menu.url,
            target: menu.target,
            menuTitle: menu.title
          });
        });
        return alphabetMenus;
      }
    }
  },

  created() {
    this.getGrammarList();
    this.getExample();
  },

  methods: {
    getGrammarList() {
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getgrammarlist", fd)
        .then(result => {
          if (result.status === 200) {
            this.grammarList = result.body.data;
          } else {
            // console.log('Err');
          }
        });
    },

    urlPrefixer(url) {
      return this.$route.params.ln !== undefined
        ? "/" + this.$route.params.ln + url
        : url;
    },

    getExample() {
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getrandomparables", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.example = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getGrammarList();
        this.getExample();
      }
    }
  },

  metaInfo() {
    return {
      title: this.ls_GrammarRules
    };
  },

  components: {
    "sidebar-menu": SidebarNavigation
  }
};
</script>

<style lang="scss" scoped>
.grammar-container {
  background-color: #ffffff;
  border: 1px solid #ededed;
  padding: 20px;

  .grammar-title {
    color: #008080;
    padding: 1rem;
    font-weight: 700;
    border-bottom: 2px solid #008080;
    margin-bottom: 1rem;
  }

  .grammar-tab-content {
    padding-left: 15px;
    padding-right: 15px;

    .grammar-tab-item {
      display: block;
      color: #ffffff;
      height: 100%;
      padding: 1rem 0.5rem;
      margin-right: -15px;
      margin-left: -15px;
      cursor: pointer;
      text-decoration: none;
      transition: all 0.3s ease-in-out;

      .item-number {
        font-size: 22px;
        text-align: center;
      }

      .item-title {
        padding: 0 15px;
        margin-bottom: 0;
        text-align: center;
      }

      &:hover {
        opacity: 0.8;
      }
    }

    .grammar-content-item {
      margin-top: 1.5rem;

      .content-title {
        font-weight: 600;
        font-size: 26px;
      }

      .grammar-tab-content {
        color: #777777;
        text-align: justify;
      }
    }
  }
}

.about-examples {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #dddfe2;
  padding: 2rem;
  background-color: #ffffff;
  font-size: 1.125rem;
  font-weight: 600;
  font-style: italic;
  font-family: Roboto, Arial, Helvetica, sans-serif;

  .example-content {
    color: #555555;
  }

  .example-author {
    color: #333333;
    text-align: right;
    font-weight: 700;
  }
}

/* RTL */

.rtl-layout {

  .cyrl-example {

    .example-content {
      text-align: right;
      direction: rtl;
    }

    .example-author {
      text-align: left;
    }
  }
}
</style>

<style>
.grammar-content-item {
  margin: 0 -15px;
}
.grammar-content-item p {
  margin-bottom: 0;
}
</style>
